// extracted by mini-css-extract-plugin
module.exports = {"upgrade-plan__text":"upgradePlanModal_upgrade-plan__text__2WJk8","upgrade-plan__actions":"upgradePlanModal_upgrade-plan__actions__25JmQ"};